import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { axiosInstance } from '../lib/api_client'

const downloadCsv = async (path: string, filename: string) => {
  const response = await axiosInstance.get<string>(path, {
    responseType: 'text',
    transformResponse: [(data: string) => data],
  })
  const blob = new Blob([response.data], { type: 'text/csv;charset=utf-8' })
  const url = URL.createObjectURL(blob)
  const link = document.createElement('a')
  link.href = url
  link.download = filename
  link.click()
  URL.revokeObjectURL(url)
}

const MercariShopsDesk = () => {
  const { t } = useTranslation()
  const [busy, setBusy] = useState(false)
  const [percent, setPercent] = useState('10')

  useEffect(() => {
    axiosInstance.get<{ percent: number }>('/mercari_shops/markup')
      .then((response) => setPercent(String(response.data.percent)))
      .catch(() => undefined)
  }, [])

  const run = (task: () => Promise<void>) => {
    setBusy(true)
    task().catch(() => alert(t('account.sell.mercari.download_failed'))).finally(() => setBusy(false))
  }

  const savePercent = async () => {
    const value = Number(percent)
    if (!Number.isInteger(value)) throw new Error('markup')
    await axiosInstance.patch('/mercari_shops/markup', { percent: value })
  }

  const download = (path: string, filename: string) => () => run(async () => {
    await savePercent()
    await downloadCsv(path, filename)
  })

  const recordIds = async (file: File) => {
    const body = new FormData()
    body.append('file', file)
    const response = await axiosInstance.post<{ updated: number, warnings: number }>('/mercari_shops/product_ids', body)
    const recorded = t('account.sell.mercari.recorded', { count: response.data.updated })
    const warnings = response.data.warnings
    alert(warnings > 0 ? `${recorded}\n${t('account.sell.mercari.duplicate_codes', { count: warnings })}` : recorded)
  }

  return (
    <>
      <hr />
      <h2>{ t('account.sell.mercari.title') }</h2>
      <p>{ t('account.sell.mercari.intro') }</p>
      <p>{ t('account.sell.mercari.images') }</p>
      <p>{ t('account.sell.mercari.defaults') }</p>
      <p>{ t('account.sell.mercari.record_help') }</p>
      <p>
        <label>
          { t('account.sell.mercari.markup') }
          {' '}
          <input
            type="number"
            min={ 0 }
            max={ 100 }
            step={ 1 }
            value={ percent }
            disabled={ busy }
            onChange={ (event) => setPercent(event.target.value) }
          />
        </label>
      </p>
      <p>
        <button type="button" className="button" disabled={ busy } onClick={ download('/mercari_shops/create_csv', 'mercari_shops_create.csv') }>
          { t('account.sell.mercari.download_create') }
        </button>
        {' '}
        <button type="button" className="button" disabled={ busy } onClick={ download('/mercari_shops/update_csv', 'mercari_shops_update.csv') }>
          { t('account.sell.mercari.download_update') }
        </button>
      </p>
      <p>
        <input
          type="file"
          accept=".csv,text/csv"
          disabled={ busy }
          onChange={ (event) => {
            const file = event.target.files?.[0]
            event.target.value = ''
            if (file) run(() => recordIds(file))
          } }
        />
      </p>
    </>
  )
}

export { MercariShopsDesk }
